import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { QarepaApiObject } from '@qarepa/common';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { Observable } from 'rxjs';
import { UserRole } from '../types/user-role';
import { UserRoleApiResponse } from '../types/user-role-response';

@Injectable({
  providedIn: 'root',
})
export class WorkersHttpService {
  private http = inject(HttpClient);

  public getUserRole$(
    companyID: number,
    userID: number
  ): Observable<UserRoleApiResponse> {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/users/${userID}`;

    return this.http.get<QarepaApiObject<UserRole>>(url, {
      observe: 'response',
    });
  }
}
